import { merge } from 'lodash'

import { defaultState as checkoutPage } from './schemas/checkoutPageSchema'
import { defaultState as currencyClient } from './schemas/currencyClientSchema'

export const defaults = context => merge(checkoutPage, currencyClient(context))
